import { Routes } from '@angular/router';

import { DashboardComponent } from './dashboard.component';
import { AuthGuard } from '../guards/auth.guard';
import { CadastrarClienteComponent } from '../cliente/cadastrar-cliente/cadastrar-cliente.component';
import { ProibidoComponent } from '../proibido/proibido.component';
import { ContatoComponent } from '../contato/contato.component';
import { PedidoComponent } from '../pedido/pedido.component';
import { EtapasDoPedidoComponent } from '../pedido/etapas-do-pedido/etapas-do-pedido.component';
import { CadastrarPedidoComponent } from '../pedido/cadastrar-pedido/cadastrar-pedido.component';
import { AcompanhamentoComponent } from './../acompanhamento/acompanhamento.component';
import { RetornoPagamentoComponent } from './../pedido/retorno-pagamento/retorno-pagamento.component';
import { RelatoriosComponent } from './../relatorios/relatorios.component';
import { KitFechadoComponent } from '../kit-fechado/kit-fechado.component';
import { KitPersonalizadoComponent } from './../kit-personalizado/kit-personalizado.component';
import { AvulsoComponent } from './../avulso/avulso.component';
import { FidelidadeComponent } from '../fidelidade/fidelidade.component';
import { FechamentoFinanceiroComponent } from '../fechamento-financeiro/fechamento-financeiro.component';
import { ConsultaFechamentoFinanceiroComponent } from '../fechamento-financeiro/consulta-fechamento-financeiro/consulta-fechamento-financeiro.component';
import { CadastroFechamentoFinanceiroComponent } from '../fechamento-financeiro/cadastro-fechamento-financeiro/cadastro-fechamento-financeiro.component';
import { ControleOcorrenciaComponent } from '../controle-ocorrencia/controle-ocorrencia.component';
import { CadastrarControleOcorrenciaComponent } from '../controle-ocorrencia/cadastrar-controle-ocorrencia/cadastrar-controle-ocorrencia.component';
import { LancamentoControleOcorrenciaComponent } from '../controle-ocorrencia/lancamento-controle-ocorrencia/lancamento-controle-ocorrencia.component';
import { RepasseComponent } from '../repasse/repasse.component';
import { CarteiraDeIntegradoresComponent } from '../carteira-de-integradores/carteira-de-integradores.component';
import { MontarKitNovoComponent } from '../montar-kit-novo/montar-kit-novo.component';
import { ClassificacaoPedidosComponent } from '../classificacao-pedidos/classificacao-pedidos.component';
import { OportunidadeComponent } from '../crm/oportunidade/oportunidade.component';
import { EditarOportunidadeComponent } from '../crm/oportunidade/editar-oportunidade/editar-oportunidade.component';
import { ListaAtividadeComponent } from '../crm/atividade/lista-atividade/lista-atividade.component';
import { RZKComponent } from '../rzk/rzk.component';
import { ICDashBoardComponent } from '../icdash-board/icdash-board.component';
import { FilaComponent } from '../fila/fila.component';
import { TipoFila } from '../models/enum';
import { MinhasOcorrenciasComponent } from '../minhas-ocorrencias/minhas-ocorrencias.component';
import { LojaDeProdutosComponent } from '../loja-de-produtos/loja-de-produtos.component';
import { title } from 'process';
import { HomeComponent } from '../home/home.component';

// Rotas da dashboard
export const DashboardRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Home',
          roles: ['Administrador', 'Suporte', 'Integrador', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'home', pai: null },
        },
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard',
          roles: ['Administrador', 'Suporte', 'Integrador', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'dashboard', pai: null },
        },
      },
      {
        path: 'feed-integradores',
        component: ICDashBoardComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Feed de Integradores',
          roles: ['Administrador', 'Suporte', 'Vendedor']
        }
      },
      {
        path: 'contatos',
        component: ContatoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Contatos',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          status: false, /* false - pendente | true - já é cliente */
          permissao: { sistema: 'gi', tela: 'contatos', pai: null },
        }
      },
      {
        path: 'integradores',
        component: ContatoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Integradores',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          status: true, /* false - pendente | true - já é cliente */
          permissao: { sistema: 'gi', tela: 'integradores', pai: null },
        }
      },
      {
        path: 'integradores/novo',
        component: CadastrarClienteComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Novo Integrador',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'integradores_novo', pai: 'integradores' },
        }
      },
      {
        path: 'integradores/editar/:id',
        component: CadastrarClienteComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Integrador',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'integradores_editar', pai: 'integradores' },
        }
      },
      {
        path: 'orcamentos',
        component: PedidoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Orçamentos',
          tipo: 0,
          roles: ['Administrador', 'Suporte', 'Vendedor', 'Integrador'],
          permissao: { sistema: 'gi', tela: 'orcamentos', pai: null },
        }
      },
      {
        path: 'orcamentos/novo',
        component: CadastrarPedidoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Novo Orçamento',
          roles: ['Administrador', 'Suporte', 'Vendedor', 'Integrador'],
          permissao: { sistema: 'gi', tela: 'orcamentos_novo', pai: 'orcamentos' },
        }
      },
      {
        path: 'orcamentos/editar/:id',
        component: CadastrarPedidoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Orçamento',
          roles: ['Administrador', 'Suporte', 'Vendedor', 'Integrador'],
          permissao: { sistema: 'gi', tela: 'orcamentos_editar', pai: 'orcamentos' },
        }
      },
      {
        path: 'pedidos',
        component: PedidoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Pedidos',
          tipo: 1,
          roles: ['Administrador', 'Suporte', 'Vendedor', 'Integrador'],
          permissao: { sistema: 'gi', tela: 'pedidos', pai: null },
        }
      },
      {
        path: 'pedidos/novo',
        component: CadastrarPedidoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Novo Pedido',
          roles: ['Administrador', 'Suporte', 'Vendedor', 'Integrador'],
          permissao: { sistema: 'gi', tela: 'pedidos_novo', pai: 'pedidos' },
        }
      },
      {
        path: 'pedidos/editar/:id',
        component: CadastrarPedidoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Pedido',
          roles: ['Administrador', 'Suporte', 'Vendedor', 'Integrador'],
          permissao: { sistema: 'gi', tela: 'pedidos_editar', pai: 'pedidos' },
        }
      },
      {
        path: 'pedidos/historico',
        component: EtapasDoPedidoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Histórico do Pedido',
          roles: ['Administrador', 'Suporte', 'Vendedor', 'Integrador'],
          permissao: { sistema: 'gi', tela: 'pedidos_historico', pai: 'pedidos' },
        }
      },
      {
        path: 'pedidos/pago/:id',
        component: RetornoPagamentoComponent,
        canActivate: [AuthGuard],
        data: {
          tipo: 0,
          roles: ['Administrador', 'Suporte', 'Vendedor', 'Integrador'],
          permissao: { sistema: 'gi', tela: 'pedidos_pago', pai: 'pedidos' },
        }
      },
      {
        path: 'pedidos/pendente/:id',
        component: RetornoPagamentoComponent,
        canActivate: [AuthGuard],
        data: {
          tipo: 1,
          roles: ['Administrador', 'Suporte', 'Vendedor', 'Integrador'],
          permissao: { sistema: 'gi', tela: 'pedidos_pendente', pai: 'pedidos' },
        }
      },
      {
        path: 'pedidos/falha/:id',
        component: RetornoPagamentoComponent,
        canActivate: [AuthGuard],
        data: {
          tipo: 2,
          roles: ['Administrador', 'Suporte', 'Vendedor', 'Integrador'],
          permissao: { sistema: 'gi', tela: 'pedidos_falha', pai: 'pedidos' },
        }
      },
      {
        path: 'classificacao-pedidos',
        component: ClassificacaoPedidosComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Classificação de Pedidos',
          tipo: 1,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'classificacao-pedidos', pai: null },
        }
      },
      {
        path: 'analise-desconto',
        component: FilaComponent,
        canActivate: [AuthGuard],
        data: {
          fila: true,
          tipo: TipoFila.AnaliseDeDesconto,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'analise_desconto', pai: null },
        }
      },
      {
        path: 'monitoramento-conferencia-fila-tarefa',
        component: FilaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Monitor de Conferência',
          fila: true,
          tipo: TipoFila.MonitorConferencia,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'monitoramento-conferencia', pai: null },
        }
      },
      {
        path: 'simulacoes',
        component: FilaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Simulações de Financiamento',
          fila: true,
          tipo: TipoFila.FinSimulacao,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'central_simulacao_financiamento', pai: null },
        }
      },
      {
        path: 'monitoramento-vendas',
        component: AcompanhamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Monitor de Vendas',
          tipo: 0,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'monitoramento-vendas', pai: null },
        }
      },
      {
        path: 'monitoramento-integracao',
        component: AcompanhamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Monitor de Integração',
          tipo: 1,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'monitoramento-integracao', pai: null },
        }
      },
      {
        path: 'monitoramento-triagem',
        component: AcompanhamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Monitor de Triagem',
          tipo: 16,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'monitoramento-triagem', pai: null },
        }
      },
      {
        path: 'monitoramento-pendencia',
        component: AcompanhamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Monitor de Pendências',
          tipo: 17,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'monitoramento-pendencia', pai: null },
        }
      },
      {
        path: 'monitoramento-financiamento',
        component: AcompanhamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Monitor de Financiamento',
          tipo: 2,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'monitoramento-financiamento', pai: null },
        }
      },
      {
        path: 'monitoramento-financeiro',
        component: AcompanhamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Monitor Financeiro',
          tipo: 3,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'monitoramento-financeiro', pai: null },
        }
      },
      {
        path: 'monitoramento-separacao',
        component: AcompanhamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Monitor de Separação',
          tipo: 4,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'monitoramento-separacao', pai: null },
        }
      },
      {
        path: 'monitoramento-faturamento',
        component: AcompanhamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Monitor Fiscal',
          tipo: 5,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'monitoramento-faturamento', pai: null },
        }
      },
      {
        path: 'monitoramento-expedicao',
        component: AcompanhamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Monitor de Expedição',
          tipo: 6,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'monitoramento-expedicao', pai: null },
        }
      },
      {
        path: 'monitoramento-pedidos',
        component: AcompanhamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Monitor de Pedidos',
          tipo: 10,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'monitoramento-pedidos', pai: null },
        }
      },
      {
        path: 'monitoramento-conferencia',
        component: AcompanhamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Monitor de Conferência',
          tipo: 12,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'monitoramento-conferencia', pai: null },
        }
      },
      {
        path: 'monitoramento-verificacao',
        component: AcompanhamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Monitor de Verificação',
          tipo: 13,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'monitoramento-verificacao', pai: null },
        }
      },
      {
        path: 'monitoramento-analise-financeira',
        component: AcompanhamentoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Monitor de Análise Financeira',
          tipo: 14,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'monitoramento-analise-financeira', pai: null },
        }
      },
      {
        path: 'monitoramento-faturamento-tec',
        component: AcompanhamentoComponent,
        canActivate: [AuthGuard],
        data: {
          tipo: 15,
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'monitoramento-faturamento-tec', pai: null },
        }
      },
      {
        path: 'proibido',
        component: ProibidoComponent,
        data: {
          title: 'Acesso Negado',
        }
      },
      {
        path: 'relatorios',
        component: RelatoriosComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Relatórios',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'relatorios', pai: null },
        }
      },
      {
        path: 'montar-kit',
        component: MontarKitNovoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Montar kit',
          roles: ['Administrador', 'Suporte', 'Integrador', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'montar-kit', pai: null },
        }
      },
      {
        path: 'kitfechado',
        component: KitFechadoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Kit pronto',
          roles: ['Administrador', 'Suporte', 'Integrador', 'Vendedor'],
          origem: 0,
          permissao: { sistema: 'gi', tela: 'kitfechado', pai: null },
        }
      },
      {
        path: 'loja-de-produtos/:id',
        component: LojaDeProdutosComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Loja de Produtos',
          lojaProdutos: true,
          origem: 0,
          roles: ['Administrador', 'Suporte', 'Integrador', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'loja-de-produtos', pai: null },
        }
      },
      {
        path: 'kitplus',
        component: KitFechadoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Kit Plus',
          roles: ['Administrador', 'Suporte', 'Integrador', 'Vendedor'],
          origem: 1,
          permissao: { sistema: 'gi', tela: 'kitplus', pai: null },
        }
      },
      {
        path: 'kitplus2',
        component: KitFechadoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Kit Plus 2',
          roles: ['Administrador', 'Suporte', 'Integrador', 'Vendedor'],
          origem: 2,
          permissao: { sistema: 'gi', tela: 'kitplus2', pai: null },
        }
      },
      {
        path: 'kitpersonalizado',
        component: KitPersonalizadoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Personalize seu Kit',
          nome: 'Personalize seu kit',
          tipo: 0,
          roles: ['Administrador', 'Suporte', 'Integrador', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'montar-kit', pai: null },
        }
      },
      {
        path: 'avulso',
        component: AvulsoComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Avulso',
          tipo: 1,
          roles: ['Administrador', 'Suporte', 'Integrador', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'avulso', pai: null },
        }
      },
      {
        path: 'repasses',
        component: RepasseComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Repasses',
          roles: ['Administrador', 'Suporte', 'Integrador', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'repasses', pai: null },
        }
      },
      {
        path: 'minhas-ocorrencias',
        component: MinhasOcorrenciasComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Minhas Ocorrências',
          roles: ['Administrador', 'Suporte', 'Integrador'],
          // permissao: { sistema: 'gi', tela: 'minhas-ocorrencias', pai: null },
        }
      },
      {
        path: 'configuracoes',
        loadChildren: () => import('../configuracoes/configuracoes.module').then(m => m.ConfiguracoesModule),
        canActivate: [AuthGuard],
        data: {
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'configuracoes', pai: null },
        }
      },
      {
        path: 'fidelidade',
        component: FidelidadeComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fidelidade',
          roles: ['Administrador', 'Suporte', 'Integrador', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'fidelidade', pai: null },
        }
      },
      {
        path: 'fechamento-financeiro',
        component: FechamentoFinanceiroComponent,
        canActivate: [AuthGuard],
        data: {
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'fechamento-financeiro', pai: null },
        }
      },
      {
        path: 'fechamento-financeiro/consulta',
        component: ConsultaFechamentoFinanceiroComponent,
        canActivate: [AuthGuard], data: {
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'fechamento-financeiro_consulta', pai: 'fechamento-financeiro' },
        }
      },
      {
        path: 'fechamento-financeiro/novo',
        component: CadastroFechamentoFinanceiroComponent,
        canActivate: [AuthGuard],
        data: {
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'fechamento-financeiro_novo', pai: 'fechamento-financeiro' },
        }
      },
      {
        path: 'fechamento-financeiro/editar/:id',
        component: CadastroFechamentoFinanceiroComponent,
        canActivate: [AuthGuard],
        data: {
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'fechamento-financeiro_editar', pai: 'fechamento-financeiro' },
        }
      },
      {
        path: 'controle-ocorrencia',
        component: ControleOcorrenciaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Ocorrências',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'controle-ocorrencia', pai: null },
        }
      },
      {
        path: 'controle-ocorrencia/novo',
        component: CadastrarControleOcorrenciaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Nova Ocorrência',
          roles: ['Administrador', 'Suporte', 'Vendedor', 'Integrador'], //, 'Vendedor'],
          // permissao: { sistema: 'gi', tela: 'controle-ocorrencia_novo', pai: 'controle-ocorrencia'},
        }
      },
      {
        path: 'controle-ocorrencia/editar/:id',
        component: CadastrarControleOcorrenciaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Alterar Ocorrência',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'controle-ocorrencia_editar', pai: 'controle-ocorrencia' },
        }
      },
      {
        path: 'controle-ocorrencia/lancamento',
        component: LancamentoControleOcorrenciaComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Detalhes da Ocorrência',
          roles: ['Administrador', 'Vendedor', 'Suporte'],
          // permissao: { sistema: 'gi', tela: 'controle-ocorrencia_lancamento', pai: null},
        }
      },
      {
        path: 'carteira-de-integradores',
        component: CarteiraDeIntegradoresComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Carteira de Integradores',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'carteira-de-integradores', pai: null },
        }
      },
      {
        path: 'energy-advisor',
        component: RZKComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Energy Advisor',
          roles: ['Integrador']
        }
      },
      {
        path: 'energy-advisor/integrador/:id',
        component: RZKComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'crm/oportunidades',
        component: OportunidadeComponent,
        canActivate: [AuthGuard], data: {
          title: 'CRM - Oportunidades',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'crm', pai: null }
        }
      },
      {
        path: 'crm/oportunidades/editar/:id',
        component: EditarOportunidadeComponent,
        canActivate: [AuthGuard], data: {
          title: 'Alterar Oportunidade',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'oportunidades_editar', pai: 'oportunidades' }
        }
      },
      {
        path: 'crm/atividades',
        component: ListaAtividadeComponent,
        canActivate: [AuthGuard], data: {
          title: 'CRM - Atividades',
          roles: ['Administrador', 'Suporte', 'Vendedor'],
          permissao: { sistema: 'gi', tela: 'atividades', pai: 'crm' }
        }
      },
      {
        path: 'financiamento',
        loadChildren: () => import('../financiamento/financiamento.module').then(m => m.FinanciamentoModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'crm-vendas',
        loadChildren: () => import('../orcamento/orcamento.module').then(m => m.OrcamentoModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'notificacao',
        loadChildren: () => import('../notificacao/notificacao.module').then(m => m.NotificacaoModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'gestao-tarefas',
        loadChildren: () => import('../gestao-de-tarefas/gestao-de-tarefas.module').then(m => m.GestaoDeTarefasModule),
        canActivate: [AuthGuard],
      },
    ]
  }
];
